import React from "react";
import Brokoli from "../../assets/images/brokoli.png";

const PopupAddingProduct = (props) => {
  return (
    <>
    <div className="bg-gray-300 opacity-50 h-full w-full absolute"></div>
      <div className="fixed h-full w-full overflow-hidden">
        <div className="relative bg-white w-full max-w-md ml-auto mr-auto opacity-100 pt-auto rounded-md">
          <div className="flex flex-col h-full">
            <div className="flex justify-between items-center px-8 border-b border-gray-100 pb-4">
              <img width="120" src={Brokoli} alt=""/>
              <div className="flex flex-col mr-20">
                  <div><h3 className="mt-4 text-2xl text-gray-700">Brokoli</h3></div>
                  <div><small>250kg</small></div>
              </div>
              <button onClick={props.handdleClick} className="h-4 w-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 18.461 19.883"
                >
                  <g
                    id="Group_3838"
                    data-name="Group 3838"
                    transform="translate(1.413 1.413)"
                  >
                    <line
                      id="Line_434"
                      data-name="Line 434"
                      x1="15.635"
                      y2="17.057"
                      fill="none"
                      stroke="#596375"
                      strokeLinecap="round"
                      strokeWidth="2"
                    />
                    <line
                      id="Line_435"
                      data-name="Line 435"
                      x2="15.635"
                      y2="17.057"
                      fill="none"
                      stroke="#596375"
                      strokeLinecap="round"
                      strokeWidth="2"
                    />
                  </g>
                </svg>
              </button>
            </div>
            <div className="bg-white flex flex-col px-8 py-3 flex-auto">
              <div className="flex flex-col items-end">
                <div className="flex-auto">
                  <span className="w-1/4 text-gray-700 mr-8">Harga jual</span>
                  <input
                    className="form-input mt-4 w-6/12"
                    placeholder=""
                    defaultValue="Rp 18.000"
                  ></input>
                </div>
                <div className="flex-auto">
                  <span className="w-4/12 text-gray-700 mr-8">Harga modal</span>
                  <input
                    className="form-input mt-4 w-6/12"
                    placeholder=""
                    defaultValue="Rp 18.000"
                  ></input>
                </div>
                <div className="flex-auto">
                  <span className="w-4/12 text-gray-700 mr-8">Diskon</span>
                  <input
                    className="form-input mt-4 w-8/12"
                    placeholder=""
                    defaultValue="Rp 1.000"
                  ></input>
                </div>
                <div className="flex-auto">
                  <span className="w-1/4 text-gray-700 mr-8">Stok</span>
                  <input
                    className="form-input mt-4 w-8/12"
                    placeholder=""
                    defaultValue="100"
                  ></input>
                </div>
              </div>
            </div>
            {/* Footer Login */}
            <div className="flex flex-col justify-between items-center py-4 px-8 ">
              <a
                href="/merchandise"
                className="bg-orange-500 w-3/12 text-white rounded-l-full rounded-r-full px-4 py-3 capitalize text-center mt-8"
              >
                Tambah
              </a>
            </div>
            {/* End Footer Login */}
          </div>
        </div>
      </div>
    </>
  );
};

export default PopupAddingProduct;
